import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskAllTaskRPage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskAllTaskRPage;
